<template lang="pug">
    .row.game-preview
        .game-title
            img.game-title__image(:src="gameFromTrainerConfig.img")
            .game-title__name {{ $i18n.t(gameFromTrainerConfig.label) }}
        .game-content
            .game__label {{ $i18n.t('billing.billing_subscriptions_amountOfStudents') }}
            .game-input
                cs-input(
                    :style="{'font-size': '15px'}"
                    type='number',
                    @input.prevent.native = "bonusGameProfile.value = handleDigitInput($event)",
                    @blur="updateValue()"
                    :value='bonusGameProfile.value',
                )
</template>

<script>
    import CsInput from '../../../elements/CsInput';
    import BonusGamesApi from '../../../api/bonusGames/bonusGames.js';
    import handleDigitInput from '../../../utils/trainer/handleOnlyDigitsInput';
    import TrainerConfig from '../../../config/trainer.json';

    export default {
        props: {
            profile: Object,
        },
        data() {
            return {
                showSchools: false,
            };
        },
        methods: {
            handleDigitInput,
            updateValue() {
                BonusGamesApi.update(this.bonusGameProfile);
            },
        },
        computed: {
            bonusGameProfile() {
                return this.profile;
            },
            gameFromTrainerConfig() {
                const profileSlug = this.profile.gameName[0].toUpperCase() + this.profile.gameName.slice(1);
                return TrainerConfig.games.find(
                    ({ slug, courseType }) => slug === profileSlug && courseType === this.profile.courseType
                );
            },
        },
        components: {
            CsInput,
        },
    };
</script>
<style lang="scss" scoped>
    .game-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        @include media($md) {
            justify-content: space-between;
            flex-direction: row;
            align-items: center;
        }
    }

    .game-title {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            font-size: 16px;
        }
    }

    .game-title__image {
        width: 70px;
        @include media($md) {
            margin-right: 15px;
        }
    }

    .game__label {
        min-width: 0;
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($lg) {
            font-size: 16px;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .game-input {
        flex-grow: 5;
        width: 65px;
        @include media($md) {
            margin-left: 15px;
        }
        @include media($lg) {
            width: 200px;
        }
    }

    .game-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include media($md) {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }
</style>
